import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useStyles, ModalSubmitButton, ModalCancelButton } from './style/style';
import { Grid, TextField, Snackbar } from '@material-ui/core';
import { editFileFolderById } from '../../../apicalls/cloud/cloudFile';
import { editPictureFolderById } from '../../../apicalls/cloud/cloudPicture';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { checkResData } from '../../../utils/common';
import { useSnackbar } from 'notistack';

type TFprops = {
  folderId: number;
  folderName: string;
  getFolderFileList: any;
  openEditFolderModal: boolean;
  setOpenEditFolderModal: React.Dispatch<React.SetStateAction<boolean>>;
};

type TPprops = {
  folderId: number;
  folderName: string;
  getFolderPictureList: any;
  openEditFolderModal: boolean;
  setOpenEditFolderModal: React.Dispatch<React.SetStateAction<boolean>>;
};

// 資料フォルダ名編集
export const FileFolderEditField: React.FC<TFprops> = (props: TFprops) => {
  const {
    openEditFolderModal,
    setOpenEditFolderModal,
    getFolderFileList,
    folderId,
    folderName
  } = props;
  // スタイル読み込み
  const classes = useStyles();
  // メッセージ
  const { enqueueSnackbar } = useSnackbar();
  // 変更名
  const [name, setName] = useState<string>(folderName);

  const EditFileFolder = () => {
    editFileFolderById(folderId, name).then(resData => {
      console.log('フォルダ名変更');
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        getFolderFileList();
        setTimeout(() => {
          setOpenEditFolderModal(false);
        }, 2000);
      });
    });
  };

  return (
    <>
      <form className={classes.paper}>
        <Grid container>
          <Grid item xs={12} style={{ padding: 36 }}>
            <div style={{ textAlign: 'center' }}>
              <h1 style={{ marginBottom: 24, fontSize: 16 }}>
                フォルダ名を編集
              </h1>
              <div className={classes.container}>
                <div style={{ marginRight: 24, fontSize: 14 }}>フォルダ名</div>
                <TextField
                  variant='outlined'
                  value={name}
                  style={{ width: 407 }}
                  onChange={e => {
                    setName(e.target.value);
                  }}
                  inputProps={{
                    maxLength: 20
                  }}
                />
              </div>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalFooter}>
            <ModalCancelButton
              variant='contained'
              onClick={() => {
                setOpenEditFolderModal(false);
              }}
            >
              キャンセル
            </ModalCancelButton>
            <ModalSubmitButton
              variant='contained'
              onClick={() => {
                EditFileFolder();
              }}
            >
              変更する
            </ModalSubmitButton>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

// 写真フォルダ名編集
export const PictureFolderEditField: React.FC<TPprops> = (props: TPprops) => {
  const {
    openEditFolderModal,
    setOpenEditFolderModal,
    folderId,
    folderName,
    getFolderPictureList
  } = props;
  // スタイル読み込み
  const classes = useStyles();
  // メッセージ
  const { enqueueSnackbar } = useSnackbar();
  // 変更名
  const [name, setName] = useState<string>(folderName);

  const EditPictureFolder = () => {
    editPictureFolderById(folderId, name).then(resData => {
      console.log('フォルダ名変更');
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        getFolderPictureList();
        setTimeout(() => {
          setOpenEditFolderModal(false);
        }, 2000);
      });
    });
  };

  return (
    <>
      <form className={classes.paper}>
        <Grid container>
          <Grid item xs={12} style={{ padding: 36 }}>
            <div style={{ textAlign: 'center' }}>
              <h1 style={{ marginBottom: 24, fontSize: 24 }}>
                フォルダ名を編集
              </h1>
              <div className={classes.container}>
                <div style={{ marginRight: 24 }}>フォルダ名</div>
                <TextField
                  variant='outlined'
                  value={name}
                  style={{ width: 360 }}
                  onChange={e => {
                    setName(e.target.value);
                  }}
                  inputProps={{
                    maxLength: 20
                  }}
                />
              </div>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalFooter}>
            <ModalCancelButton
              variant='contained'
              onClick={() => {
                setOpenEditFolderModal(false);
              }}
            >
              キャンセル
            </ModalCancelButton>
            <ModalSubmitButton
              variant='contained'
              onClick={() => {
                EditPictureFolder();
              }}
            >
              変更する
            </ModalSubmitButton>
          </Grid>
        </Grid>
      </form>
    </>
  );
};
